import * as assert from 'assert';
import * as React from 'react';
import { getDisplayNameFromTagType, AddPhotoConstants as ui, FRESHDESK } from '../../Config/UIConstants';
import { TagType } from '../../Services/PhotoService';
import { CommonTextInput } from '../../SharedComponents/CommonTextInput';
import { IUploadedPhoto } from '../../Stores/UserPhotoStore';
import { ModalXIconInverse } from '../../images/images';
import { styles } from '../PhotosPage/AddPhotosStyle';

interface IProps {
    tagType: TagType;
    image: IUploadedPhoto;
    onImageUpdate(image: IUploadedPhoto): void;
}

export class PhotoDataInput extends React.Component<IProps> {
    private static getStateKeyFromTagType(tagType: TagType): keyof IUploadedPhoto {
        const stateKey: string | undefined = TagType[tagType];
        if (stateKey) {
            return stateKey.toLowerCase() as keyof IUploadedPhoto;
        }
        throw new Error(`Invalid tag type name provided to getStateKeyFromTagType: ${tagType}`);
    }

    public render() {
        const { tagType, image, onImageUpdate } = this.props;
        let header = getDisplayNameFromTagType(tagType);
        let shouldDisable = false;
        let stateUpdateKey = PhotoDataInput.getStateKeyFromTagType(tagType);
        let placeholder: string | undefined = undefined;
        let helpLink: string | undefined = undefined;

        const currentImage = image || {};
        let value = currentImage[stateUpdateKey] || '';

        if (value === '' && tagType === TagType.FILENAME) {
            value = 'Unnamed File';
        }

        switch (tagType) {
            case TagType.DATE:
                placeholder = 'MM / DD / YYYY';
                helpLink = FRESHDESK.WHEN;
                break;
            case TagType.FILENAME:
                shouldDisable = true;
                placeholder = '';
                break;
            case TagType.LOCATION:
                placeholder = ui.CITY_STATE;
                helpLink = FRESHDESK.WHERE;
                break;
            default:
                assert(false, 'no case was found for @renderPhotoDataInput switch statement');
        }

        const updateImageState = (text: string) => {
            const img = { ...currentImage };
            img[stateUpdateKey] = text;
            onImageUpdate(img);
        };

        return (
            <div style={styles.input(shouldDisable)}>
                <CommonTextInput
                    disabled={shouldDisable}
                    value={value}
                    containerStyle={styles.inputContainer}
                    onChangeText={updateImageState}
                    header={header}
                    placeholder={placeholder}
                    maxLength={this.props.tagType === TagType.DATE ? 30 : 50}
                    showMaxLengthOnFocus={true}
                    hideButtonOnFocus={true}
                    sideButton={(focus: () => void) => {
                        return tagType !== TagType.FILENAME ? (
                            <div
                                style={styles.inputCancel}
                                onClick={() => {
                                    updateImageState('');
                                    focus();
                                }}
                            >
                                {<img src={ModalXIconInverse} style={styles.cancelIcon} />}
                            </div>
                        ) : (
                            <div />
                        );
                    }}
                    helpLink={helpLink}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Pages/AddPhotosPage/PhotoDataInput.tsx